import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  questions: [],
  loading: false,
  error: null
};

const eligibilityQuestion = createSlice({
  name: 'eligibilityQuestion',
  initialState,
  reducers: {
    setQuestions: (state, action) => {
      state.questions = action.payload;
      state.loading = false;
    },
    addQuestion: (state, action: any) => {
      state.questions = [...state.questions, action.payload] as any;
    },
    updateQuestion: (state, action) => {
      state.questions = state.questions.map((question: any) => (question._id === action.payload._id ? action.payload : question)) as any;
    },
    deleteQuestion: (state, action) => {
      state.questions = state.questions.filter((question: any) => question._id !== action.payload) as any;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const { setQuestions, addQuestion, updateQuestion, deleteQuestion, setLoading, setError } = eligibilityQuestion.actions;

export default eligibilityQuestion.reducer;
